import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ListaFuncionariosLayer from "../components/ListaFuncionariosLayer";
import { useTranslation } from "../i18n/I18nContext";

const ListaFuncionariosPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("funcionario.breadcrumb.list")} />
      <ListaFuncionariosLayer />
    </MasterLayout>
  );
};

export default ListaFuncionariosPage;
